import { useMutation } from '@tanstack/react-query';
import { useInvalidateFilesQueries } from '@/api/hooks/useInvalidateFileQueries';
import type { CreateFolder } from '@trinity/chat/api/interfaces/workspaces';
import Toast from '@trinity/chat-components/components/Toast/index.js';
import type { CreateFolderParams } from '../interfaces';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';

type Props = {
  onSuccess?: (res: CreateFolder.Response) => void;
};

export const useCreateFolder = (props: Props = {}) => {
  const invalidateQueries = useInvalidateFilesQueries();

  const apiClient = useChatApiClient();

  return useMutation({
    mutationKey: ['create-folder'], mutationFn: (data: CreateFolderParams) => {
      return apiClient.workspaces.createFolder({
        name: data.name,
        parentObjectId: data.parentObjectId,
        workspaceId: data.workspaceId,
      });
    }, onSuccess: data => {
      Toast.alert({
        title: 'New Folder Created',
      });
      invalidateQueries();
      props.onSuccess?.(data);
    }, onError: e => {
      Toast.error({
        title: 'Error',
        body: `We're sorry, there was an issue creating your folder`,
      });
    },
  });
};

export default useCreateFolder;